<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Sora', sans-serif;
  margin-top: 20px;
  font-size: 0.9rem;
  zoom: 89%;
}
:root {
  /* --primary-color: #198754; */
  --primary-color: #2b1987;
  --primary-hover: #157347;
  --primary-light: #e9f7ef;

  --secondary-color: #00b98e;
  --tertiary-color: #1e90ff;
  --toolbar-color: #07622b;

  --background-color: #f6fbf8;
  --soft-background: #f6fbf8;
  --card-background: #ffffff;

  --text-color: #333333;
  --muted-color: #777777;
  --border-color: rgba(25, 135, 84, 0.08);

  --bs-success: #198754;
  --bs-success-rgb: 25, 135, 84;
}
</style>